import styled from 'styled-components';

export const QualityButton = styled.button`
  cursor: pointer;
  flex: none;
`;

export const QualityButtonContainer = styled.div`
  display: flex;
  height: 100%;
`;
